// extracted by mini-css-extract-plugin
export default {"header":"style_header__4sJbK","headerContent":"style_headerContent__9Nivy","title":"style_title__uKB0-","menus":"style_menus__IEUz4","menuItem":"style_menuItem__kBvn0"};